/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssetOcppConfigurationKeyDto
 */
export interface AssetOcppConfigurationKeyDto {
    /**
     * 
     * @type {string}
     * @memberof AssetOcppConfigurationKeyDto
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof AssetOcppConfigurationKeyDto
     */
    value: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetOcppConfigurationKeyDto
     */
    readonly: boolean | null;
}

/**
 * Check if a given object implements the AssetOcppConfigurationKeyDto interface.
 */
export function instanceOfAssetOcppConfigurationKeyDto(value: object): value is AssetOcppConfigurationKeyDto {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('readonly' in value) || value['readonly'] === undefined) return false;
    return true;
}

export function AssetOcppConfigurationKeyDtoFromJSON(json: any): AssetOcppConfigurationKeyDto {
    return AssetOcppConfigurationKeyDtoFromJSONTyped(json, false);
}

export function AssetOcppConfigurationKeyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetOcppConfigurationKeyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'value': json['value'],
        'readonly': json['readonly'],
    };
}

export function AssetOcppConfigurationKeyDtoToJSON(json: any): AssetOcppConfigurationKeyDto {
    return AssetOcppConfigurationKeyDtoToJSONTyped(json, false);
}

export function AssetOcppConfigurationKeyDtoToJSONTyped(value?: AssetOcppConfigurationKeyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'value': value['value'],
        'readonly': value['readonly'],
    };
}

